var path = 'components/packages/tooltips/announcementSubscribers.html';
var html = "<div ng-repeat=\"subscr in a.subscribers\"><b ng-bind=subscr.accountNumber></b> - <span ng-bind=\"subscr.firstname + ' ' + subscr.lastname\"></span></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;